/**
 * @param {{onClose: () => void}} param0
 */
export default function CloseButton({ onClose }) {
  /**
   * @param {Event} e
   */
  const close = (e) => {
    e.preventDefault();
    onClose();
  };

  return (
    <button className={'shipmondo-modal_close'} onClick={close}>
      <span aria-hidden="true">&times;</span>
    </button>
  );
}
